import React, { useMemo, useState, Fragment } from 'react'
import { withWindowSizeListener } from 'react-window-size-listener'
import { useHistory, useLocation } from 'react-router-dom'
import text from '../../constants/Menu'
import { FiArrowLeft, FiTrash2 } from 'react-icons/fi'
import '../../styles/containers/PerfilCarousel.css'
import Carousel from '../../components/Carousel'
import useLanguage from '../../hooks/useLanguage'
import Popup from '../../services/PopupTwoButtons'
import API from '../../services/Api'

const RememberYouCarousel = props => {
  const location = useLocation()
  const history = useHistory()

  const [currentPhoto, setCurrentPhoto] = useState(0)
  const [openPopup, setOpenPopup] = useState(false)
  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false)
  const [commentFeedbackPopup, setCommentFeedbackPopup] = useState('')
  const [isLoadingPopup, setIsLoadingPopup] = useState(false)

  const [photos, setPhotos] = useState(location.state && location.state.photos)
  const initialPhoto = useMemo(() => location.state && location.state.initialPhoto, [location.state])
  const language = useLanguage()

  if (!photos) {
    history.replace('/remember-you')
    return <div />
  }

  const deleteRememberYouPopup = () => {
    return (
      <Popup
        open={openPopup}
        close={() => setOpenPopup(false)}
        closeButton={false}
        textHeader='Tem certeza que deseja apagar esta lembrança?'
        textButton='Sim'
        buttonAction={() => handleDeleteRememberYou(photos[currentPhoto])}
        isTwoButtons
        textTwoButton='Não'
        loading={isLoadingPopup}
      />
    )
  }

  const feedbackConsultantRememberYouPopup = () => {
    return (
      <Popup
        open={openFeedbackPopup}
        close={() => setOpenFeedbackPopup(false)}
        closeButton
        textHeader='Este é o Feedback de sua consultora!'
        textParagraph={commentFeedbackPopup}
        textButton='OK'
        buttonAction={() => setOpenFeedbackPopup(false)}
        loading={isLoadingPopup}
      />
    )
  }

  const handleDeleteRememberYou = async rememberYou => {
    setIsLoadingPopup(true)
    const rememberYouId = rememberYou.id

    await API.deleteRememberYouById(props.token, rememberYouId)
      .then(() => {
        const updatedPhotos = photos.filter(item => item.id !== rememberYouId)
        setPhotos(updatedPhotos)
        if (updatedPhotos.length < 1) {
          history.replace('/rememberyou')
        }
      })
      .finally(() => {
        setIsLoadingPopup(false)
        setOpenPopup(false)
      })
  }

  return (
    <Fragment>
      {deleteRememberYouPopup()}
      {feedbackConsultantRememberYouPopup()}
      <div className='perfil-slide-container'>
        <div className='perfil-slide-title'>
          <FiArrowLeft onClick={() => history.goBack()}
            size={24} color='var(--primary)' className='perfil-slide-goback' />
          <p>{text.rememberedYou[language]}</p>
          <FiTrash2 onClick={() => setOpenPopup(true)}
            size={24} color='var(--red)' className='perfil-slide-goback' />
        </div>
        <Carousel
          photos={photos}
          initialPhoto={initialPhoto}
          currentPage={setCurrentPhoto} setCommentFeedbackPopup={comment => {
            setCommentFeedbackPopup(comment)
            setOpenFeedbackPopup(true)
          }} />
      </div>
    </Fragment>
  )
}

export default withWindowSizeListener(RememberYouCarousel)



// WEBPACK FOOTER //
// ./src/containers/RememberedYou/RememberYouCarousel.js